module.exports = __webpack_public_path__ + "static/img/section_1_bg.2987007.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.0/mobile/section_1_bg.jpg
// module id = WZ8h
// module chunks = 0